export const APP_STATES = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  EDITING: 'EDITING',
  CREATING: 'CREATING',
} as const;

export const APP_STORAGE_KEY = `surveyApp` as const;
